import { Button, Spin } from "antd";
import { cloneElement } from "react";
import "./MondayButton.scss";
import { motion } from "motion/react";

const MondayButton = ({
  children,
  disabled = false,
  Icon,
  onClick,
  className = "mondayButtonGreen",
  hasIcon = false,
  containerClassName,
  form,
  key,
  style,
  testid = "",
  spin = false,
  htmlType = "button",
  ...rest
}) => (
  <div
    className={`mondayButtonContainer ${containerClassName}`}
    // style={style}
  >
    <Button
      htmlType={htmlType}
      data-testid={testid}
      onClick={onClick}
      className={`mondayButtonStyle ${className}`.trim()}
      disabled={!!spin || disabled}
      style={style}
      form={form}
      key={key}
      {...rest}
    >
      {children && (
        <div className="mondayButtonText" style={{ gap: !!spin ? 5 : 0 }}>
          <motion.div
            style={{ display: "flex" }}
            animate={{
              transform: !!spin ? "translateX(0px)" : "translateX(15px)",
            }}
          >
            <Spin spinning={!!spin} size="small" />
          </motion.div>
          {children}
        </div>
      )}
      {children && hasIcon && (
        <div
          className="mondayButtonDivider"
          style={!!disabled ? { backgroundColor: "#C8C8C8" } : {}}
        />
      )}
      {Icon && cloneElement(Icon, { className: "mondayButtonIcon" })}
    </Button>
  </div>
);

export default MondayButton;
